import React from 'react';
import WebpackerReact from 'webpacker-react';
import DeletedRecordsView from '../components/formatos/DeletedRecords/Index';

function DeletedRecords(props) {
    return <DeletedRecordsView {...props} />;
}

export default DeletedRecords;
WebpackerReact.setup({ DeletedRecords });
